import { Avatar, Dropdown, Flex, MenuProps, Segmented } from 'antd'
import { useGetUser } from '../api/user/user.ts'
import { useDarkMode } from '../hooks/useDarkMode.tsx'
import { ThemePreference } from '../utils/theme.ts'
import {
    DesktopOutlined,
    LogoutOutlined,
    MoonOutlined,
    SettingOutlined,
    SunOutlined,
} from "@ant-design/icons"

const THEME_OPTIONS: Array<{ value: ThemePreference; label: string; icon: JSX.Element }> = [
    { value: 'system', label: 'System', icon: <DesktopOutlined/> },
    { value: 'light', label: 'Light', icon: <SunOutlined/> },
    { value: 'dark', label: 'Dark', icon: <MoonOutlined/> },
]

export const UserControlComponent = () => {
    const { data: userInfo } = useGetUser()
    const { preference, setPreference } = useDarkMode()

    const items: MenuProps['items'] = [
        {
            key: 'user',
            type: 'group',
            label: userInfo?.email,
            children: [
                {
                    key: 'settings',
                    label: <Flex justify="space-between" gap={12}>Account Settings <SettingOutlined/></Flex>,
                    onClick: () => {
                        if (userInfo?.accountSettingsUrl) {
                            window.location.href = userInfo.accountSettingsUrl
                        }
                    }
                },
                {
                    key: 'theme',
                    label: (
                        <Flex justify="space-between" align="center" gap={12} onClick={(e) => e.stopPropagation()}>
                            Theme
                            <Segmented
                                size="small"
                                value={preference}
                                onChange={(value) => setPreference(value as ThemePreference)}
                                options={THEME_OPTIONS.map(({ value, label, icon }) => ({ value, icon, title: label }))}
                            />
                        </Flex>
                    ),
                },
                {
                    key: 'login',
                    label: <Flex justify="space-between" gap={12}>Logout <LogoutOutlined/></Flex>,
                    onClick: () => {
                        if (userInfo) {
                            window.location.href =
                                userInfo.logoutUrl + '?redirect_to=' + window.location.href
                        }
                    }
                }
            ],
        }
    ]

    const menuProps: MenuProps = {
        items
    }

    const avatarTitle = userInfo?.email && userInfo.email[0].toUpperCase()

    return (
        <Dropdown
            menu={menuProps}
            overlayStyle={{ height: '32px' }}
            trigger={['click']}
        >
            <Avatar style={{
                cursor: 'pointer',
                backgroundColor: 'var(--ant-color-primary)',
                color: '#fff'
            }}>
                {avatarTitle}
            </Avatar>
        </Dropdown>
    )
}
